// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import ContentLoaderController from "./content_loader_controller"
application.register("content-loader", ContentLoaderController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MainController from "./main_controller"
application.register("main", MainController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NoticeController from "./notice_controller"
application.register("notice", NoticeController)

import PhoneNumpadController from "./phone_numpad_controller"
application.register("phone-numpad", PhoneNumpadController)

import RadioController from "./radio_controller"
application.register("radio", RadioController)

import SettingController from "./setting_controller"
application.register("setting", SettingController)
